class YoutubeContainer {
	constructor(el) {
		this._handlePlayClick = this._handlePlayClick.bind(this)

		if (!el) {
			throw Error(`YoutubeContainer did not receive an element.`)
		}

		this.el = el
		this._playerIFrame = this.el.querySelector('iframe[data-role="js--youtube-container-player"]')
		this._playButton = this.el.querySelector('[data-role="js--youtube-container-play-button"]')
		this._playButton.addEventListener('click', this._handlePlayClick)
	}
	_handlePlayClick(event) {
		const playCommand = JSON.stringify({
			event: 'command',
			func: 'playVideo'
		})

		// Load event is fired whenever iframe.src is changed and new content has loaded,
		// so listen for load before setting src
		this._playerIFrame.addEventListener('load', event => {
			event.target.contentWindow.postMessage(playCommand, '*')
		})
		this._playerIFrame.src = this._playerIFrame.getAttribute('data-src')
		this.el.classList.add('is-playing')
		event.preventDefault()
	}
}

/*
Chrome youtube load issue:
https://stackoverflow.com/questions/48714879/error-parsing-header-x-xss-protection-google-chrome
*/

export default YoutubeContainer
